import type { HelpGroup, HelpTopic } from '../types';
import { proposalsTopics } from './proposals';
import { estimatesDesignsTopics } from './estimates-designs';
import { worksAsTopics } from './works-as';
import { tendersTopics } from './tenders';
import { contractorsTopics } from './contractors';
import { progressTopics } from './progress';
import { mappingTopics } from './mapping';

export const HELP_TOPICS: HelpTopic[] = [
  ...proposalsTopics,
  ...estimatesDesignsTopics,
  ...worksAsTopics,
  ...tendersTopics,
  ...contractorsTopics,
  ...mappingTopics,
  ...progressTopics,
];

export const HELP_TOPIC_INDEX: Record<string, HelpTopic> = Object.fromEntries(
  HELP_TOPICS.map((t) => [t.id, t])
);

export const HELP_GROUPS: HelpGroup[] = [
  {
    id: 'lifecycle',
    title: 'Works Lifecycle',
    icon: 'ri-flow-chart',
    topicIds: [
      'wms.proposals.create',
      'wms.estimates.create',
      'wms.designs.create',
      'wms.works.create-in-as',
      'wms.as.create-from-unsanctioned-works',
      'wms.funds.source-details',
    ],
  },
  {
    id: 'tenders',
    title: 'Packages & Tenders',
    icon: 'ri-file-paper-2-line',
    topicIds: ['wms.work-packages.create', 'wms.tenders.create', 'wms.tenders.award'],
  },
  {
    id: 'contractors',
    title: 'Contractors & Users',
    icon: 'ri-user-star-line',
    topicIds: [
      'wms.contractors.create',
      'wms.contractor-users.create',
      'wms.contractors.assign-in-award',
      'wms.contractors.users-from-profile',
    ],
  },
  {
    id: 'mapping',
    title: 'GIS & Sachivalayam Mapping',
    icon: 'ri-road-map-line',
    topicIds: ['wms.mapping.sachivalayam', 'wms.mapping.gis'],
  },
  {
    id: 'progress',
    title: 'Progress & Billing',
    icon: 'ri-hammer-line',
    topicIds: ['wms.progress.physical-milestones', 'wms.progress.financial-milestones'],
  },
];
